<template>
  <LoadingWrapper :loading="loading">
    <template #loading>
      <Loading />
    </template>
    <template #default>
      <CardList
        accordion=""
        :items="items"
        loadingComponent="Parvandeh"
        :showBody="handleShowBodyFn"
      >
        <template slot="header" slot-scope="{ item }">
          <b-row class="margin-0 width-percent-100">
            <b-col cols="12" lg="4" class="padding-0">
              <ProfileBoxPopupWrapper :data="item" deskTopPopupClass="top-235">
                <LazyImageBox
                  :src="item.image"
                  :fullName="item.fullName"
                  :parvandehNumber="item.parvandehNumber"
                  :firstCaption="item.termCaption"
                  :secondCaption="item.companyName"
                />
              </ProfileBoxPopupWrapper>
            </b-col>
            <b-col
              cols="12"
              lg="4"
              class="padding-x-16 mobile-padding-x-0 tablet-padding-x-0"
            >
              <slot name="center-col" :item="item"></slot>
            </b-col>
            <b-col cols="12" lg="4" class="padding-0">
              <slot name="left-col" :item="item"></slot>
            </b-col>
          </b-row>
        </template>
        <template slot="body" slot-scope="{ item }">
          <slot name="body" :item="item" :bodyData="bodyData"></slot>
        </template>
      </CardList>
    </template>
  </LoadingWrapper>
</template>

<script>
import {
  LoadingWrapper,
  CardList,
  LazyImageBox,
  ProfileBoxPopupWrapper,
} from "@/components/re-design/";
import Loading from "./Loading.vue";
import { inject, provide, ref } from "vue";
import { pathOr } from "ramda";
import { generateError } from "@/shared/utils";

export default {
  components: {
    LoadingWrapper,
    CardList,
    LazyImageBox,
    Loading,
    ProfileBoxPopupWrapper,
  },
  props: {
    showBodyFn: {
      type: Function,
      default: null,
    },
  },
  setup(props) {
    const loading = inject("LOADING");
    const items = inject("PARVANDEH_ITEMS");

    provide("HEADER_LOADING", false);

    // open card body and call async service for get body data
    const bodyDataCached = ref([]);
    const bodyData = ref(null);
    const handleShowBodyFn =
      typeof props.showBodyFn === "function"
        ? async (item) => {
            const id = pathOr(null, ["id"], item);
            try {
              // check exist in cache data
              const cacheData = bodyDataCached.value.find(
                (item) => item.id === id
              );
              if (cacheData) {
                bodyData.value = cacheData;
                return;
              }

              const response = await props.showBodyFn(item);
              // add response to item body
              bodyData.value = response;
              // add response with unique id to cache data array
              bodyDataCached.value.push({ ...response });
            } catch (error) {
              generateError(error);
            }
          }
        : () => {};

    // return data to be used in template
    return { loading, items, bodyData, handleShowBodyFn };
  },
};
</script>
